<template>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
        <div class="cropper_content">
            <div class="crop_box">
                <vueCropper
                    ref="cropper"
                    :fixed="fixed"
                    :fixed-number="fixedNumber"
                    :img="originImgUrl"
                    :full="option.full"
                    :output-type="option.outputType"
                    :can-move="option.canMove"
                    :info="option.info"
                    :auto-crop="option.autoCrop"
                    :auto-crop-width="option.autoCropWidth"
                    :auto-crop-height="option.autoCropHeight"
                    :center-box="option.centerBox"
                    :info-true="option.infoTrue"
                    :original="option.original"
                    :mode="option.mode"
                    @real-time="realTime"
                ></vueCropper>
            </div>

            <div :style="previewStyle3">
                <div :style="previews.div">
                    <img :src="previews.url" :style="previews.img" />
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="finish">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper';
export default {
    name: 'ModalImageCrop',
    components: {
        VueCropper,
    },
    props: ['fixed', 'fixedNumber', 'originImgUrl', 'dialogVisible'],
    data() {
        return {
            previews: {},
            option: {
                img:
                    'http://upload.ajmide.com/t/image/202004/29/nrsnYFJJEw1588141372415_2800x1600.jpg',
                size: 1,
                info: true,
                outputType: 'png',
                canMove: false,
                fixedBox: false,
                canMoveBox: true,
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 400,
                autoCropHeight: 400,
                centerBox: true,
                infoTrue: true,
                original: false,
                full: true,
                canScale: false,
                mode: 'contain'
            },
            imageUrl: '',
            previewStyle3: null
        };
    },
    methods: {
        finish() {
            const _this = this;
            this.$refs.cropper.getCropBlob((data) => {
                var img = window.URL.createObjectURL(data);
                _this.$emit('success', {
                    img,
                    blobData: data
                });
            });
        },
        // 实时预览函数
        realTime(data) {
            const previews = data;
            this.previews = data;

            //   固定为100宽度
            this.previewStyle3 = {
                width: previews.w + 'px',
                height: previews.h + 'px',
                overflow: 'hidden',
                margin: '0',
                zoom: 100 / previews.w,
            };
        },

        cancel() {
            this.$emit('cancel');
        },
    },
};
</script>

<style scoped>
.crop_box {
    width: 400px;
    height: 400px;
    margin-right: 10px;
}
.cropper_content {
    display: flex;
}
</style>
